import type { IconProps } from '../types/IconProps.ts';
export const GalleryHorizontal: IconProps = {
    name: 'GalleryHorizontal',
    children: [
        `<path d="M2 3v18M22 3v18" />`,
        `<rect width="12" height="18" x="6" y="3" rx="2" />`,
    ]
};